import {combineReducers} from 'redux';
import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux';

// Reducers
import PrefixReducer from '../../services/prefix/reducer';
import SessionReducer from '../../services/session/reducer';
import DashboardReducer from '../../scenes/Dashboard/reducer';
import ProjectsReducer from '../../services/projects/reducer';
import ActiveProject from '../../services/activeProject/reducer';
import EmailReducer from '../../services/userDetails/reducer_email';
import PasswordReducer from '../../services/userDetails/reducer_password';
import LoginInProgress from '../../services/userDetails/reducer_login_in_progress';
import MarkSpot from '../../services/markSpot/reducer';
import OARReducer from './search/oarReducer.js';
import AgeReducer from './search/ageReducer';
import DistanceReducer from './search/distanceReducer';
import StepReducer from './search/stepReducer';
import OldAgeReducer from './search/oldAgeReducer';
import savedSearch from './search/savedSearch';
import savedSearchFilters from './search/savedSearchFilters';
import adhocFilters from './adhoc/filters';
import adhocBase from './adhoc/base';
import EducationReducer from './search/educationReducer';
import IncomeReducer from './search/incomeReducer';
import prefFans from './search/prefFans';
import saved from './search/saved';
import old_age_adhoc from './adhoc/old_age';

// RRD
import rrdData from './rrd/data';
import savedSearchData from './saved_search_data/data';
import prioritychangeid from './prioritychangeid/prioritychangeid'
import item_ommitted from './item_ommitted/item_ommitted';
import customer from './general/customer';
import customer_email from './general/customer_email';
import candidate from './dash/candidate';
import byName from './search/byName';

// Population Counts
import first from './search/popCount/first';
import second from './search/popCount/second';
import third from './search/popCount/third';
import fourth from './search/popCount/fourth';
import fifth from './search/popCount/fifth';
import sixth from './search/popCount/sixth';

/*
 * We combine all reducers into a single object before updated data is dispatched (sent) to store
 * Your entire applications state (store) is just whatever gets returned from all your reducers
 * */

const allReducers = combineReducers({
    routing: routerReducer,
    prefix: PrefixReducer,
    session: SessionReducer,
    dashboard: DashboardReducer,
    projects: ProjectsReducer,
    activeProject: ActiveProject,
    oar: OARReducer,
    education: EducationReducer,
    income: IncomeReducer,
    email: EmailReducer,
    password: PasswordReducer,
    loginInProgress: LoginInProgress,
    markSpot: MarkSpot,
    distance: DistanceReducer,
    age: AgeReducer,
    step: StepReducer,
    old_age: OldAgeReducer,
    saved_search: savedSearch,
    saved_search_filters: savedSearchFilters,
    pref_fans: prefFans,
    first_pop_count: first,
    second_pop_count: second,
    third_pop_count: third,
    fourth_pop_count: fourth,
    fifth_pop_count: fifth,
    sixth_pop_count: sixth,
    rrd_data: rrdData,
    prioritychangeid: prioritychangeid,
    item_ommitted: item_ommitted,
    saved: saved,
    customer: customer,
    candidate: candidate,
    search_by_name: byName,
    savedSearchData: savedSearchData,
    customer_email: customer_email,
    adhoc_filters: adhocFilters,
    adhoc_base: adhocBase,
    adhoc_old_age: old_age_adhoc,
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/config/allReducers/index.js